export default function PreparationItemCommentDirective() {
  return {
    template: require('./preparation-item-comment.html'),
    scope: {
      preparationItemId: '=',
      canEdit: '=',
      canDelete: '=',
      preparationItemComment: '=',
    },
    controller: 'PreparationItemCommentController',
    controllerAs: 'preparationItemCommentVM',
    bindToController: true,
    replace: true
  };
}
